import React, { useRef, useEffect, useState, useContext } from "react";
import MainCard from "ui-component/cards/MainCard";
import DragAndDrop from "views/Components/ServicesOperationComponent/Add_Product/DragAndDrop";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider, fontFamily } from "@mui/system";
import Modal_Filtro from "views/Components/ServicesOperationComponent/Helper/Modal_Filtro";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import AddItemForm from "views/Components/ServicesOperationComponent/Add_Product/AddItemForm";
import { AppGlobalContext } from "contexts/GlobalContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        height: "100%",
      }}
    >
      {value === index && <Box sx={{ p: 0, height: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ServiceOperationPage = (props) => {
  const { mainCountry } = useContext(AppGlobalContext);
  const [country, setCountry] = React.useState(mainCountry);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const divRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const ML_URL = `${baseUrl}/ServiceOperation/UploadFileContent`;
  const MANUAL_URL = `${baseUrl}/ServiceOperation/UploadCustomFileContent`;

  useEffect(() => {
    setCountry(mainCountry);
  }, [mainCountry]);

  useEffect(() => {
    // size update
    const updateSize = () => {
      if (divRef.current) {
        const { width, height } = divRef.current.getBoundingClientRect();

        setSize({ width, height });
      }
    };

    // set initial size
    updateSize();

    window.addEventListener("resize", updateSize);

    // remove event controller
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: '"Montserrat", sans-serif',
    },
  });
  return (
    <div style={mainDiv} ref={divRef}>
      <Stack spacing="24px">
        <Box
          sx={{
            backgroundColor: "white",
            height: "auto",
            width: "100%",
            borderRadius: "4px",
            background: "#FFF",
          }}
        >
          <Stack spacing={1}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                fontSize: "32px",
                color: "#000000DE",
                lineHeight: "24px",
              }}
            >
              Ingreso de devoluciones
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#000000DE",
                lineHeight: "24px",
              }}
            >
              Supervisores · Registro inicial del paquete físico recibido.
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              backgroundColor: "#E5F6FD",
              padding: 1.5,
              borderRadius: 1,
              mt: 2,
            }}
          >
            <InfoOutlinedIcon sx={{ color: "#0288D1" }} />
            <Stack direction="column">
              <Typography
                sx={{ color: "#014361", fontSize: "16px", fontWeight: 500 }}
              >
                Escanea el código de barras o ingresa el N° de seguimiento.
              </Typography>
              <Typography sx={{ color: "#014361", fontSize: "14px" }}>
                El sistema completa los datos automáticamente.
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ mt: 2 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Ingreso de devoluciones"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                borderRadius: "6px",
                width: "fit-content",
                border: "1px solid #0000001F",
                overflow: "hidden",
                minHeight: "48px",
                height: "48px",
                "& .MuiTabs-flexContainer": {
                  height: "100%",
                },
              }}
            >
              <Tab
                label="Formulario"
                {...a11yProps(0)}
                sx={{
                  height: "100%",
                  color: "#000000DE",
                  "&.Mui-selected": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                  "&:hover": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                }}
              />
              <Tab
                label="Mercado Libre"
                {...a11yProps(1)}
                sx={{
                  height: "100%",
                  color: "#000000DE",
                  "&.Mui-selected": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                  "&:hover": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                  borderRight: "1px solid #0000001F",
                }}
              />
              <Tab
                label="Manual"
                {...a11yProps(2)}
                sx={{
                  height: "100%",
                  color: "#000000DE",
                  "&.Mui-selected": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                  "&:hover": {
                    backgroundColor: "#002878",
                    color: "#FFFFFF",
                  },
                  borderRight: "1px solid #0000001F",
                }}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <AddItemForm />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <DragAndDrop url={ML_URL} country={country} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <DragAndDrop url={MANUAL_URL} country={country} />
          </CustomTabPanel>

          {/* <Modal_Filtro/> */}
        </Box>
      </Stack>
    </div>
  );
};

export default ServiceOperationPage;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};

const mainCard = {
  height: "100%",
  border: "0px solid red",
  fontFamily: "Montserrat, sans-serif",
};
